import React, {useState} from 'react'
import styled from 'styled-components'
import {Add} from '@mui/icons-material'
import Popover from '@mui/material/Popover'
import Fab from '@mui/material/Fab'
import Card from 'components/CreateCard/Card'

const Menu = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`

const Button = styled(Fab)`
	top: 90px;
	margin-right: 30px;
	position: fixed;
	right: 0;
	z-index: 1300;
	transition: background-color .3s cubic-bezier(.55, 0, .1, 1), transform .3s cubic-bezier(.55, 0, .1, 1);
`

const images = [
    {
        icon: 'list',
        name: 'lst'
    },
    {
        icon: 'scheduler',
        name: 'sch'
    },
    {
        icon: 'planning',
        name: 'pln'
    },
    {
        icon: 'excel',
        name: 'excel'
    },
    {
        icon: 'graphiccard',
        name: 'gph'
    },
    {
        icon: 'widgetcard',
        name: 'wdg'
    }
]

const CreateCard = ({handleOpen}) => {
	const [anchorEl, setAnchor] = useState(null)

    const togglePopover = (e) => {
        if (anchorEl) {
            setAnchor(null)
        } else {
            setAnchor(e.currentTarget)
        }
    }

    const onOpen = (type) => {
		setAnchor(null)
        handleOpen(type)
    }

	return (
		<React.Fragment>
			<Button sx={anchorEl ? {transform: 'rotate(45deg)', backgroundColor: '#81979f'} : {}}
				color="primary"
				onClick={togglePopover}
			>
				<Add fontSize='large' />
			</Button>
			<Popover
				sx={{
					zIndex: '1200'
				}}
				open={!!anchorEl}
				anchorEl={anchorEl}
				onClose={togglePopover}
				BackdropProps={{
					sx: {
						backgroundColor: 'rgba(238, 238, 238, 0.7)'
					}
				}}
				PaperProps={{
					sx: {
						margin: '20px',
						maxWidth: '700px'
					}
				}}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				<Menu>
					{images.map((item, index) =>
						<Card key={index}
							icon={item.icon}
							name={item.name}
							onClick={() => onOpen(item.name)}
						/>
					)}
				</Menu>
			</Popover>
		</React.Fragment>
	)
}

export default CreateCard
